import abortionEvent from './events/abortionEvent'

const events =
{
    abortionEvent
};

export default events ;